import React from "react"
import { DropDownContainer } from "./dropDownMenu"

export const ResponsiveToolbar: React.FC = ({ children }) => {

    return <DropDownContainer>
        {
            toggle => <>
                <div className="dropdown dropleft d-block d-md-none">
                    <a className="btn btn-outline-secondary dropdown-toggle" onClick={toggle} href="#" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="fas fa-ellipsis-v" />
                    </a>
                    <div className="dropdown-menu">
                        {
                            React.Children.map(children, child => <span className="dropdown-item">{child}</span>)
                        }
                    </div>
                </div>
                <div className="d-none d-md-block">
                    {children}
                </div>
            </>
        }
    </DropDownContainer>
}